import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M10.996 3.128c.174 0 .288.196.234.361-.1.313-.167.687-.203.92a.266.266 0 0 1-.253.223 6.638 6.638 0 0 0 .222 13.27 6.637 6.637 0 0 0 6.634-6.795.276.276 0 0 1 .236-.277c.296-.047.577-.144.833-.284.172-.094.403.003.416.199q.018.258.018.52a8.1 8.1 0 0 1-1.878 5.199l3.506 3.505a.751.751 0 0 1-1.062 1.061l-3.505-3.506a8.137 8.137 0 1 1-5.198-14.396" />
    <path d="M17.459 0c.236 0 .446.143.534.355l.03.096c.257 1.14.594 1.846 1.082 2.335.49.489 1.197.826 2.336 1.083a.577.577 0 0 1 0 1.127l-.408.1c-.905.244-1.5.555-1.928.982-.36.36-.636.838-.86 1.519q-.12.367-.222.817a.58.58 0 0 1-.563.451h-.01a.6.6 0 0 1-.123-.017l-.047-.013-.053-.02-.017-.01a.58.58 0 0 1-.315-.39 11 11 0 0 0-.17-.644c-.232-.774-.522-1.303-.912-1.693-.488-.489-1.196-.825-2.336-1.082a.578.578 0 0 1 0-1.127q.16-.037.307-.076l.262-.072c.815-.237 1.366-.533 1.768-.935.488-.489.825-1.196 1.081-2.335A.58.58 0 0 1 17.46 0" />
  </>
);

const SearchSparkle = Icon('search-sparkle', svgContents);

export default SearchSparkle;
